var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#34445B"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.937 10.222l2.01-3.136a2.03 2.03 0 00.83-3.97 2.03 2.03 0 00-2.04 3.2l-2.494 3.891a7.96 7.96 0 00-7.142 8.707 7.965 7.965 0 008.706 7.142 7.965 7.965 0 007.143-8.706 7.967 7.967 0 00-7.013-7.128zm-.915 12.122a4.22 4.22 0 01-4.224-4.223 4.22 4.22 0 014.224-4.224 4.22 4.22 0 013.95 2.732 2.442 2.442 0 00-3.424-.433 2.441 2.441 0 00-.433 3.424 2.441 2.441 0 003.849.007 4.214 4.214 0 01-3.942 2.717z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.937 10.222l2.01-3.136a2.03 2.03 0 00.83-3.97 2.03 2.03 0 00-2.04 3.2l-2.494 3.891a7.96 7.96 0 00-7.142 8.707 7.965 7.965 0 008.706 7.142 7.965 7.965 0 007.143-8.706 7.967 7.967 0 00-7.013-7.128zm-.915 12.122a4.22 4.22 0 01-4.224-4.223 4.22 4.22 0 014.224-4.224 4.22 4.22 0 013.95 2.732 2.442 2.442 0 00-3.424-.433 2.441 2.441 0 00-.433 3.424 2.441 2.441 0 003.849.007 4.214 4.214 0 01-3.942 2.717z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOst);
export default __webpack_public_path__ + "static/media/ost.2e59308148879f749c56ba14ef354f2a.svg";
export { ForwardRef as ReactComponent };